import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { OnboardingStep } from '@heidi/growth/contracts';
import { type OrganisationRole, type OrganisationSize } from '@heidi/schema/ml-scribe';

export function trackOrganisationSurveySubmitted(input: {
  name: string;
  size?: OrganisationSize;
  role?: OrganisationRole;
  ehrProvider?: string;
  specialtyId?: string;
  specialtyName?: string;
  otherSpecialty?: string;
  isOfficialPractice?: boolean;
  cqcPracticeId?: string;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.Survey,
    props: {
      action: SegmentActionName.OrganisationSurveySubmitted,
      organisationName: input.name,
      organisationSize: input.size,
      organisationRole: input.role,
      ehrProvider: input.ehrProvider,
      specialtyId: input.specialtyId,
      specialtyName: input.specialtyName,
      otherSpecialty: input.otherSpecialty,
    },
  });

  track({
    options: { amplitude: false },
    event_name: TrackingEventName.OrganisationSurveySubmitted,
    props: {
      organisation_name: input.name,
      organisation_size: input.size,
      organisation_role: input.role,
      ehr_provider: input.ehrProvider,
      specialty_id: input.specialtyId,
      specialty_name: input.specialtyName,
      other_specialty: input.otherSpecialty,
      is_official_practice: input.isOfficialPractice,
      cqc_practice_id: input.cqcPracticeId,
    },
  });

  // V2 — survey_submitted
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SurveySubmitted,
    props: {
      survey_type: 'organisation_survey',
    },
  });

  track({
    event_name: TrackingEventName.OnboardingStepCompleted,
    props: {
      step: OnboardingStep.CUSTOMIZE_ORGANIZATION,
      organisation_size: input.size,
      organisation_role: input.role,
      ehr_provider: input.ehrProvider,
    },
  });
}
